/**
 * @file STS Pop Up
 */

import { gsap } from 'gsap';

/**
 * STS Pop Up Component
 */
const vStsPopup = () => {
	const popup = document.querySelector( '.v-sts-pop-up' );

	if ( ! popup ) {
		return;
	}

	// const popupId         = popup.getAttribute( 'data-id' );
	const closeBtn     = popup.querySelector( '.v-sts-pop-up__close' );
	const popupContent = popup.querySelector( '.v-sts-pop-up__inner' );
	// const dismissedPopups = JSON.parse( localStorage.getItem( 'v-sts-dismissed' ) || '[]' );
	let prevFocus;

	/**
	 * Open Pop Up
	 */
	const popupOpen = () => {
		prevFocus = popup.ownerDocument.activeElement;
		gsap.to( popupContent, {
			opacity: 1,
			onStart: () => {
				popup.setAttribute( 'aria-hidden', 'false' );
			},
			onComplete: () => {
				popupContent.classList.add( 'v-sts-pop-up__inner--visible' );
				popupContent.removeAttribute( 'style' );
				popupContent.focus();
			},
		} );
	};

	/**
	 * Close Pop Up
	 *
	 * @param {Event} e The click event
	 */
	const popupClose = ( e ) => {
		e.preventDefault();

		gsap.to( popupContent, {
			opacity:    0,
			onComplete: () => {
				popup.setAttribute( 'aria-hidden', 'true' );
				popupContent.classList.remove( 'v-sts-pop-up__inner--visible' );
				popupContent.removeAttribute( 'style' );
				prevFocus.focus();
				/* dismissedPopups.push( popupId );
				localStorage.setItem( 'v-sts-dismissed', JSON.stringify( dismissedPopups ) ); */
			},
		} );
	};

	popupContent.addEventListener( 'focusout', ( e ) => {
		e.preventDefault();

		if (
			popup.getAttribute( 'aria-hidden' ) === 'false' &&
			e.relatedTarget &&
			! popupContent.contains( e.relatedTarget )
		) {
			popupContent.focus();
		} else {
			prevFocus.focus();
		}
	} );

	// verify key codes
	popupContent.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) {
			popupClose();
		}
	} );

	popup.addEventListener( 'click', ( e ) => {
		const { target } = e;
		if ( ! popupContent.contains( target ) ) {
			popupClose( e );
		}
	} );

	closeBtn.addEventListener( 'click', popupClose );

	setTimeout( () => {
		/* if ( dismissedPopups.includes( popupId ) ) {
			return;
		} */
		popupOpen();
	}, 10000 );
};

export default vStsPopup;
